<template>
  <a
    v-if="captchaStore.state.captchaVerified"
    class="callback-button"
    :href="'tel:' + $filters.phoneFormat(phone.number)"
    :class="phone.class"
  >
    <img src="@/assets/i/call.svg" alt="Позвонить" />
  </a>
</template>

<script>
import { resolvePhone } from "@/utils/phones";

export default {
  inject: ["mainStore", "captchaStore"],
  computed: {
    phone() {
      return resolvePhone(
        this.$route.name,
        this.mainStore.state.data?.addresses.addr_list[1]?.addr_phone || ""
      );
    },
  },
};
</script>

<style scoped>
.callback-button {
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  background: linear-gradient(135deg, #d3d0ff, #ff0020, #fff);
  transition: all 0.5s;
}
</style>
